import * as constants from './constants';

export function fetchMarketSettings() {
  return {
    type: constants.FETCH_MARKET_SETTINGS
    // payload: market
  };
}
export function fetchMarketSettingsDone(payload) {
  return {
    type: constants.FETCH_MARKET_SETTINGS_DONE,
    payload
  };
}
export function fetchMarketSettingsFail(error) {
  return {
    type: constants.FETCH_MARKET_SETTINGS_FAIL,
    payload: error
  };
}

export function onChangeMarketSettingsData(payload) {
  return {
    type: constants.ONCHANGE_MARKET_SETTINGS_DATA,
    payload
  };
}

export function saveMarketSettings(payload, callback) {
  return {
    type: constants.SAVE_MARKET_SETTINGS,
    payload,
    callback
  };
}
export function saveMarketSettingsDone(payload) {
  return {
    type: constants.SAVE_MARKET_SETTINGS_DONE,
    payload
  };
}
export function saveMarketSettingsFail(error) {
  return {
    type: constants.SAVE_MARKET_SETTINGS_FAIL,
    payload: error
  };
}
